// import logo from './logo.svg';
// import './App.css';
import Header from './components/Header';
import Banner from './components/banner';
function App() {
  return (
    <div>
     <Header/>
     <Banner/>
    </div>
  );
}

export default App;
